"use strict";
exports.__esModule = true;
var angular = require("angular");
var STORAGE_KEYS = {
    portfolio: 'portfolio',
    treeNode: 'treenode',
    firstLevelParentNode: 'firstLevelParentNode',
    isArchivedNode: 'isArchivedNode',
    menuItem: 'menu',
    reportOptions: 'options',
    treeFilters: 'SessionTreeFilters',
    treeExcludeFilters: 'SessionTreeExcludeFilters',
    defaultTreeFilters: 'DefaultTreeFilters',
    defaultTreeExcludeFilters: 'DefaultTreeExcludeFilters'
};
angular.module('smartorg.r6.cmpts.shareLink', []).factory('shareLink', [function () {
        var _a;
        var shareLinkService = {
            item: (_a = {
                    portfolio: undefined,
                    treenode: undefined,
                    menu: undefined,
                    options: undefined
                },
                _a[STORAGE_KEYS.treeFilters] = undefined,
                _a[STORAGE_KEYS.treeExcludeFilters] = undefined,
                _a[STORAGE_KEYS.defaultTreeFilters] = undefined,
                _a[STORAGE_KEYS.defaultTreeExcludeFilters] = undefined,
                _a),
            getValue: function (key) {
                return shareLinkService.item[key];
            },
            setValue: function (key, value) {
                if (value === void 0) { value = ''; }
                if (typeof value !== 'undefined' && value !== null) {
                    shareLinkService.item[key] = value;
                    localStorage.setItem(key, value);
                }
                else {
                    localStorage.removeItem(key);
                }
            },
            clearValue: function (key) {
                shareLinkService.item[key] = undefined;
                localStorage.removeItem(key);
            },
            clearAll: function () {
                shareLinkService.item = {};
                Object.values(STORAGE_KEYS).forEach(function (k) { return localStorage.removeItem(k); });
            },
            loadItem: function () {
                shareLinkService.item[STORAGE_KEYS.portfolio] = localStorage.getItem(STORAGE_KEYS.portfolio);
                shareLinkService.item[STORAGE_KEYS.treeNode] = localStorage.getItem(STORAGE_KEYS.treeNode);
                shareLinkService.item[STORAGE_KEYS.menuItem] = localStorage.getItem(STORAGE_KEYS.menuItem);
                shareLinkService.item[STORAGE_KEYS.reportOptions] = localStorage.getItem(STORAGE_KEYS.reportOptions);
                shareLinkService.item[STORAGE_KEYS.treeFilters] = localStorage.getItem(STORAGE_KEYS.treeFilters);
                shareLinkService.item[STORAGE_KEYS.treeExcludeFilters] = localStorage.getItem(STORAGE_KEYS.treeExcludeFilters);
                shareLinkService.item[STORAGE_KEYS.defaultTreeFilters] = localStorage.getItem(STORAGE_KEYS.defaultTreeFilters);
                shareLinkService.item[STORAGE_KEYS.defaultTreeExcludeFilters] = localStorage.getItem(STORAGE_KEYS.defaultTreeExcludeFilters);
            },
            setItems: function () {
                shareLinkService.setValue(STORAGE_KEYS.portfolio, shareLinkService.item[STORAGE_KEYS.portfolio]);
                shareLinkService.setValue(STORAGE_KEYS.treeNode, shareLinkService.item[STORAGE_KEYS.treeNode]);
                shareLinkService.setValue(STORAGE_KEYS.menuItem, shareLinkService.item[STORAGE_KEYS.menuItem]);
                shareLinkService.setValue(STORAGE_KEYS.reportOptions, shareLinkService.item[STORAGE_KEYS.reportOptions]);
                shareLinkService.setValue(STORAGE_KEYS.treeFilters, shareLinkService.item[STORAGE_KEYS.treeFilters]);
                shareLinkService.setValue(STORAGE_KEYS.treeExcludeFilters, shareLinkService.item[STORAGE_KEYS.treeExcludeFilters]);
                shareLinkService.setValue(STORAGE_KEYS.defaultTreeFilters, shareLinkService.item[STORAGE_KEYS.defaultTreeFilters]);
                shareLinkService.setValue(STORAGE_KEYS.defaultTreeExcludeFilters, shareLinkService.item[STORAGE_KEYS.defaultTreeExcludeFilters]);
            },
            getInfoString: function () {
                return JSON.stringify(shareLinkService.item);
            },
            loadItemFromString: function (input) {
                shareLinkService.item = JSON.parse(input);
            },
            getTreeFilters: function () {
                return shareLinkService.getValue(STORAGE_KEYS.treeFilters);
            },
            setTreeFilters: function (value) {
                if (value === null)
                    value = '';
                shareLinkService.setValue(STORAGE_KEYS.treeFilters, value);
            },
            clearTreeFilters: function () {
                shareLinkService.clearValue(STORAGE_KEYS.treeFilters);
            },
            getTreeExcludeFilters: function () {
                var excludeFilterTagsStr = shareLinkService.getValue(STORAGE_KEYS.treeExcludeFilters);
                return excludeFilterTagsStr != undefined && excludeFilterTagsStr !== "" ? JSON.parse(excludeFilterTagsStr) : [];
            },
            getTreeExcludeFiltersWithoutNull: function () {
                return shareLinkService.getValue(STORAGE_KEYS.treeExcludeFilters);
                // return excludeFilterTagsStr !== undefined && excludeFilterTagsStr !=="" ? JSON.parse(excludeFilterTagsStr) : [];
            },
            setTreeExcludeFilters: function (value) {
                shareLinkService.setValue(STORAGE_KEYS.treeExcludeFilters, JSON.stringify(value));
            },
            clearTreeExcludeFilters: function () {
                shareLinkService.clearValue(STORAGE_KEYS.treeExcludeFilters);
            },
            // Default
            getDefaultTreeFilters: function () {
                return shareLinkService.getValue(STORAGE_KEYS.defaultTreeFilters);
                // return (defaultFilterTagsStr !== undefined || defaultFilterTagsStr !== "") ? JSON.parse(defaultFilterTagsStr) : [];
            },
            setDefaultTreeFilters: function (value) {
                if (value === null)
                    value = '';
                shareLinkService.setValue(STORAGE_KEYS.defaultTreeFilters, value);
            },
            clearDefaultTreeFilters: function () {
                shareLinkService.clearValue(STORAGE_KEYS.defaultTreeFilters);
            },
            getDefaultTreeExcludeFilters: function () {
                var excludeFilterTagsStr = shareLinkService.getValue(STORAGE_KEYS.defaultTreeExcludeFilters);
                return (excludeFilterTagsStr !== undefined && excludeFilterTagsStr != "") ? JSON.parse(excludeFilterTagsStr) : [];
            },
            setDefaultTreeExcludeFilters: function (value) {
                shareLinkService.setValue(STORAGE_KEYS.defaultTreeExcludeFilters, JSON.stringify(value));
            },
            clearDefaultTreeExcludeFilters: function () {
                shareLinkService.clearValue(STORAGE_KEYS.defaultTreeExcludeFilters);
            },
            getFirstLevelParentNode: function () {
                return shareLinkService.getValue(STORAGE_KEYS.firstLevelParentNode);
            },
            setFirstLevelParentNode: function (value) {
                shareLinkService.setValue(STORAGE_KEYS.firstLevelParentNode, value);
            },
            clearFirstLevelParentNode: function () {
                shareLinkService.clearValue(STORAGE_KEYS.firstLevelParentNode);
            },
            getIsArchivedNode: function () {
                return shareLinkService.getValue(STORAGE_KEYS.isArchivedNode);
            },
            setIsArchivedNode: function (value) {
                shareLinkService.setValue(STORAGE_KEYS.isArchivedNode, value);
            },
            clearIsArchivedNode: function () {
                shareLinkService.clearValue(STORAGE_KEYS.isArchivedNode);
            },
            // New methods for tree node management
            getTreeNode: function () {
                return shareLinkService.getValue(STORAGE_KEYS.treeNode);
            },
            setTreeNode: function (value) {
                shareLinkService.setValue(STORAGE_KEYS.treeNode, value);
            },
            clearTreeNode: function () {
                shareLinkService.clearValue(STORAGE_KEYS.treeNode);
            }
        };
        return shareLinkService;
    }]);
module.exports = 'smartorg.r6.cmpts.shareLink';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/components/share-link/app/js/plumbing/app.js